<template>
  <div class="ai-message-bubble" :class="messageClass">
    <div :class="contentClass">
      <div class="ai-message-row d-flex align-items-start gap-gd-1">
        <img v-if="iconSrc" :src="iconSrc" :class="iconClass" alt="">
        <div class="ai-message-text fs-sa-14 fw-400 text-default flex-fill">
          {{ message.subLabel || message.text }}
        </div>
      </div>
      <div v-if="!isUser && message.action" class="ai-message-actions d-flex align-items-center justify-content-end gap-gd-1 w-100">
        <b-button class="btn-ai-copy border-none" variant="light" @click="handleCopy">
          <i class="fal fa-copy mr-gd-half fs-sa-12"></i>
          <span class="fs-sa-12 fw-400">{{ $t('engine.aiGenerate.btnCopy', languageEngine) }}</span>
        </b-button>
        <b-button class="btn-ai-apply border-none" @click="handleApply">
          <i class="fal fa-check mr-gd-half fs-sa-12"></i>
          <span class="fs-sa-12 fw-400 text-white">{{ $t('engine.aiGenerate.btnApply', languageEngine) }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AIGenerateMessageItem',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine'
    }),
    isUser() {
      return this.message.role === 'user';
    },
    messageClass() {
      return {
        'ai-message-user': this.isUser,
        'ai-message-assistant': !this.isUser
      };
    },
    contentClass() {
      return this.isUser
        ? 'ai-message-user-content bg-blue-solitude border border-blue-andrea p-gd-2'
        : 'ai-message-assistant-content bg-white border border-gray-light p-gd-2';
    },
    iconSrc() {
      return this.isUser
        ? null
        : require('@assets/images/icon/ai_generate.svg');
    },
    iconClass() {
      return this.isUser
        ? 'ai-message-icon flex-shrink-0 mr-8'
        : 'ai-message-icon flex-shrink-0 align-self-start';
    }
  },
  methods: {
    handleCopy() {
      navigator.clipboard.writeText(this.message.text);
      this.$emit('copy', { text: this.message.text });
    },
    handleApply() {
      this.$emit('apply', { text: this.message.text });
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-message-bubble {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ai-message-user-content,
.ai-message-assistant-content {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ai-message-row {
    align-items: flex-start;
  }

  .ai-message-icon {
    width: 16px;
    height: 16px;
    margin-top: 2px;
  }

  .ai-message-text {
    line-height: 1.5;
    word-break: break-word;
  }
}

.ai-message-user-content {
  border-radius: 16px;
  border-top-right-radius: 0;
  .ai-message-text {
    line-height: 20px;
  }
}

.ai-message-assistant-content {
  border-radius: 16px;
  border-top-left-radius: 0;

  .ai-message-icon {
    width: 20px;
    height: 20px;
  }

  .ai-message-text {
    line-height: 20px;
  }
}

.ai-message-actions {
  width: 100%;
  
  .btn-ai-copy,
  .btn-ai-apply {
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    height: auto !important;
    min-height: auto !important;
  }

  .btn-ai-apply {
    background: linear-gradient(61deg, #28BEE3 0%, #7A5AF8 49.73%, #EE46BC 99.45%) !important;
    background-color: transparent !important;
    
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
